import React, { useState, useEffect, useCallback, useRef } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useTheme } from "@mui/material/styles";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import AddTaskIcon from "@mui/icons-material/AddTask";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { CloudUpload, Download as DownloadIcon } from "@mui/icons-material";
import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  IconButton,
  Paper,
  Grid,
  Tooltip,
  TextField,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
  Autocomplete,
  InputAdornment,
  Box,
} from "@mui/material";
import MDBox from "components/MDBox";
import {
  ViewButton,
  DeleteButton,
  StyledTypography,
  StyledButton,
  StyledButtonC,
  StyledAlert,
  StyledSnackbar,
  StyledAgGridContainer,
  inputStyle,
  CustomTableCell,
  StyledTypographyA,
} from "components/StyledComponents/styledComponents.js";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { entryStyles } from "components/Styles/loanEntryStyles";
import {
  selectScrollStyle,
  tableCellStyle,
  CustomPaper,
  tableShadow,
  autoSelectStyle,
  autoSelectStyle2,
  globalStyles,
} from "components/Styles/globalStyles";
import { useMaterialUIController } from "context";
import { voucherMasterStyles } from "components/Styles/voucherStyles";
import AddIcon from "@mui/icons-material/Add";
import { useAccountsApi } from "customApiHooks/accountsApi";
import Cookie from "js-cookie";
import ResponsiveTabs from "components/StyledComponents/styledComponents";

export default function ContraVoucher() {
  const [controller, dispatch] = useMaterialUIController();
  const { user } = controller;

  const [activeTab, setActiveTab] = useState(0);

  const [selectedData, setSelectedData] = useState();
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedAccountName, setSelectedAccountName] = useState("");
  const [selectedNarration, setNarration] = useState("");
  const [voucherNo, setVoucherNo] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [openFileFolder, setOpenFileFolder] = useState(false);
  const [paramsData, setParamsData] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [voucherToDelete, setVoucherToDelete] = useState(null);
  const [companyIdToDelete, setCompanyIdToDelete] = useState(null);
  const [SelectCompany, setSelectCompany] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [Company, SelectedCompany] = useState("");
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 2).toISOString().split("T")[0];
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 1)
    .toISOString()
    .split("T")[0];
  const [fromDate, setFromDate] = useState(firstDay);
  const [toDate, setToDate] = useState(lastDay);
  const [seachTypeForGet, setSeachTypeForGet] = useState("CNT");
  const theme = useTheme();
  const MInput = inputStyle();
  const [rows, setRows] = useState([{ particular: "", amount: "" }]);
  const [totalAmount, setTotalAmount] = useState(0);

  const gridRef = useRef(null);
  const [pinnedBottomData, setPinnedBottomData] = useState([]);
  const jwt_token = Cookie.get("jwt_token");

  const fmtINR = (val) => {
    const n = parseFloat(val);
    return isNaN(n)
      ? "₹ 0.00"
      : `₹ ${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const getRowStyle = (params) => {
    if (params.node.rowPinned === "bottom") {
      return {
        background: "#E59400",
        color: "#ffffff",
        fontWeight: "800",
        fontSize: "13px",
        borderTop: "2px solid #E59400",
      };
    }
    return null;
  };

  const computeAndPin = useCallback((rows) => {
    if (!rows || rows.length === 0) {
      setPinnedBottomData([]);
      return;
    }
    const total = rows.reduce((sum, row) => sum + (parseFloat(row.Amount) || 0), 0);
    setPinnedBottomData([
      {
        Date: "",
        VoucherNo: "Total",
        Particulars: "",
        Amount: total,
      },
    ]);
  }, []);

  const onFilterChanged = useCallback(() => {
    if (!gridRef.current?.api) return;
    const visibleRows = [];
    gridRef.current.api.forEachNodeAfterFilter((node) => {
      if (node.data) visibleRows.push(node.data);
    });
    computeAndPin(visibleRows);
  }, [computeAndPin]);

  const resetForm = () => {
    setSelectedAccount("");
    setVoucherNo("");
    setSelectedAccountName("");
    setNarration("");
    setSelectCompany("");
    setSelectedDate(new Date().toISOString().split("T")[0]);
    setRows([{ particular: "", amount: "" }]);
    setTotalAmount(0);
  };

  const resetFormState = () => {
    resetForm();
    setIsEditMode(false);
  };

  const {
    companies,
    accounts,
    paymentAccounts,
    tableData,
    voucherData,
    isEditMode,
    open,
    message,
    alertType,
    setOpen,
    getVoucherApi,
    manageVouchersApi,
    fetchListOfVouchers,
    handleDeleteVoucher,
    setIsEditMode,
    loading,
    showAlert,
    setLoading,
    handleCloseAlert,
  } = useAccountsApi(resetFormState);

  useEffect(() => {
    computeAndPin(tableData);
  }, [tableData, computeAndPin]);

  useEffect(() => {
    if (activeTab === 0) {
      const compId = user.companyId;
      const payload = {
        companyId: Company || compId,
        fromDate: fromDate || "2024-10-01",
        toDate: toDate || "2024-10-25",
        searchType: "CNT",
      };
      fetchListOfVouchers(payload);
    }
  }, [activeTab]);

  useEffect(() => {
    const selected = accounts.find((item) => item.accountID === selectedAccount);
    setSelectedAccountName(selected ? selected.accountName : "");
  }, [selectedAccount]);

  const ActionCellRenderer = (props) => {
    // eslint-disable-next-line react/prop-types
    if (props.node.rowPinned === "bottom") return null;

    const rowIndex = props.node.rowIndex;
    let rowData = null;
    if (props.api && props.api.getDisplayedRowAtIndex(rowIndex)) {
      rowData = props.api.getDisplayedRowAtIndex(rowIndex).data;
    } else {
      console.error("API or row data is not available.");
    }

    const handleEdit = () => {
      handleEditVoucher(rowData.voucherID, rowData.companyId);
    };

    ActionCellRenderer.propTypes = {
      data: PropTypes.shape({
        voucherID: PropTypes.number.isRequired,
        Date: PropTypes.string.isRequired,
        VoucherNo: PropTypes.string.isRequired,
        Particulars: PropTypes.string,
        Amount: PropTypes.number.isRequired,
      }).isRequired,
    };

    return (
      <div>
        <ViewButton type="button" onClick={handleEdit}>
          <EditIcon />
        </ViewButton>
        <DeleteButton
          type="button"
          onClick={() => {
            setVoucherToDelete(rowData.voucherID);
            setCompanyIdToDelete(rowData.companyId);
            setOpenDialog(true);
          }}
        >
          <DeleteIcon />
        </DeleteButton>
        <Tooltip title="Upload" arrow>
          <IconButton onClick={() => handleOpenDialogFileUploader(rowData)} color="primary">
            <CloudUpload />
          </IconButton>
        </Tooltip>
        <Tooltip title="Download" arrow>
          <IconButton onClick={() => triggerS3File(rowData)} color="primary">
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  const columnDefs = [
    {
      headerName: "Actions",
      cellRenderer: ActionCellRenderer,
      minWidth: 100,
      flex: 1,
    },
    {
      headerName: "Date",
      field: "Date",
      filter: true,
      sortable: true,
      minWidth: 140,
      flex: 1,
      cellStyle: (params) => {
        if (params.node.rowPinned === "bottom") return { fontWeight: "bold", color: "#ffffff" };
        return null;
      },
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
    {
      headerName: "Voucher No",
      field: "VoucherNo",
      filter: true,
      sortable: true,
      minWidth: 80,
      flex: 1,
      cellStyle: (params) => {
        if (params.node.rowPinned === "bottom") return { fontWeight: "bold", color: "#ffffff" };
        return null;
      },
      cellRenderer: (params) => {
        if (params.node.rowPinned === "bottom") return <span>{params.value}</span>;
        return <span>{params.value || "No Vouchers"}</span>;
      },
    },
    {
      headerName: "Particulars",
      field: "Particulars",
      minWidth: 110,
      flex: 1,
      filter: true,
      sortable: true,
      cellRenderer: (params) => {
        if (params.node.rowPinned === "bottom") return null;
        return <span>{params.value || "No Particulars"}</span>;
      },
    },
    {
      headerName: "Amount",
      field: "Amount",
      filter: true,
      sortable: true,
      minWidth: 120,
      flex: 1,
      cellStyle: (params) => ({
        textAlign: "right",
        fontWeight: params.node.rowPinned === "bottom" ? "800" : "500",
        color: params.node.rowPinned === "bottom" ? "#ffffff" : "inherit",
      }),
      valueFormatter: (params) => fmtINR(params.value),
    },
  ];

  const handleRowChange = (index, field, value) => {
    if (field === "particular") {
      const isDuplicate = rows.some((row, i) => i !== index && row[field] === value);
      if (isDuplicate) {
        showAlert(`Account already exists in particulars`, "error");
        return;
      }
    }
    let updatedValue = value;
    if (field === "amount") {
      updatedValue = value.replace(/[^0-9.]/g, "");
    }
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, [field]: updatedValue } : row
    );
    setRows(updatedRows);
    if (field === "amount") calculateTotal(updatedRows);
  };

  const calculateTotal = (updatedRows) => {
    const total = updatedRows.reduce((acc, row) => acc + Number(row.amount || 0), 0);
    setTotalAmount(total);
  };

  const handleAddItem = () => {
    setRows((prevRows) => [...prevRows, { particular: "", amount: "" }]);
  };

  const handleRemoveItem = (index) => {
    setRows((prevRows) => {
      const updatedRows = prevRows.filter((_, i) => i !== index);
      const finalRows = updatedRows.length ? updatedRows : [{ particular: "", amount: "" }];
      calculateTotal(finalRows);
      return finalRows;
    });
  };

  const handleEditVoucher = async (vid, cid) => {
    try {
      setIsEditMode(true);
      const payload = { voucherID: vid, companyID: cid };
      const data = await getVoucherApi(payload);
      if (data) {
        setSelectedData(data);
        setSelectCompany(data.companyID);
        setVoucherNo(data.voucherClientID);
        setSelectedDate(data.entryDate?.split("T")[0] || "");
        setNarration(data.narration || "");
        const creditAccountID = data.creditItems?.length > 0 ? data.creditItems[0].accountID : null;
        if (creditAccountID) {
          setSelectedAccount(creditAccountID);
        }
        const debitRows = (data.items || [])
          .filter((item) => item.accountID !== creditAccountID)
          .map((item) => ({
            particular: item.accountID,
            amount: item.amount,
            accountName: item.accountName,
            accountType: item.accountType,
          }));
        setRows(debitRows.length ? debitRows : [{ particular: "", amount: "" }]);
        calculateTotal(debitRows);
        if (data.PrintFormat) {
          const newWindow = window.open("", "_blank");
          newWindow.document.open();
          newWindow.document.write(data.PrintFormat);
          newWindow.document.close();
        }

        setActiveTab(1);
      }
    } catch (error) {
      showAlert("Error in handleEditVoucher:", error);
    }
  };

  const handleClose = () => setOpen(false);

  const handleSave = () => {
    const duplicateAccountFound = rows.some((row) => row.particular === selectedAccount);
    if (duplicateAccountFound) {
      showAlert("Accounts should be unique", "error");
      return;
    }
    const creditTotal = totalAmount;
    if (totalAmount !== creditTotal) {
      showAlert("Error: Debit and Credit totals must be equal.", "error");
      return;
    }
    if (isEditMode) {
      fetchSaveVoucher("UPDATE", selectedData.voucherID);
    } else {
      fetchSaveVoucher("ADD");
    }
  };

  const fetchSaveVoucher = async (action = "ADD", voucherID = "0") => {
    const requestType = action.toUpperCase();
    const payload = {
      companyID: user.companyId,
      RequestType: requestType,
      voucherID,
      VoucherClientID: voucherNo,
      VoucherType: "CNT",
      yearNo: 1,
      entryDate: selectedDate,
      paymentMode: "",
      paymentReference: "",
      narration: selectedNarration,
      CreateUserID: "ADMINL1",
      DebitItems: rows.map((row) => ({
        AccountType: "DR",
        AccountID: row.particular,
        Amount: row.amount,
      })),
      CreditItems: [
        {
          AccountType: "CR",
          AccountID: selectedAccount,
          Amount: totalAmount,
        },
      ],
    };
    manageVouchersApi(payload, fromDate, toDate, Company, seachTypeForGet);
    setActiveTab(0);
  };

  const fetchVoucherData = async () => {
    const payload = {
      companyId: user.companyId,
      fromDate: fromDate || "2024-10-01",
      toDate: toDate || "2024-10-25",
      searchType: "CNT",
    };
    fetchListOfVouchers(payload);
  };

  const handleOpenDialogFileUploader = (params) => {
    setParamsData(params);
    setOpenFileFolder(true);
  };

  const handleCloseFileUploader = () => {
    setOpenFileFolder(false);
    setSelectedFile(null);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".xlsx", ".xls"];
    const fileName = file.name.toLowerCase();
    const isValid = allowedExtensions.some((ext) => fileName.endsWith(ext));

    if (!isValid) {
      showAlert("Only .jpg, .jpeg, .png, .pdf, .xlsx or .xls files are allowed!", "error");
      event.target.value = null;
      return;
    }
    setSelectedFile(file);
  };

  const uploadFileToS3 = async () => {
    if (!selectedFile) {
      showAlert("Please select a file first.", "error");
      return;
    }

    if (!paramsData?.VoucherNo) {
      showAlert("Voucher information is missing. Please try again.", "error");
      return;
    }

    const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".xlsx", ".xls"];
    const fileName = selectedFile.name.toLowerCase();
    const mimeMap = {
      ".jpg": "image/jpeg",
      ".jpeg": "image/jpeg",
      ".png": "image/png",
      ".pdf": "application/pdf",
      ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ".xls": "application/vnd.ms-excel",
    };
    const ext = allowedExtensions.find((e) => fileName.endsWith(e));
    const contentType = mimeMap[ext] || "application/octet-stream";

    const uploadUrl = `https://s3service.sconexsoft.com/s3bucket/presigned-url?fileName=${paramsData.VoucherNo}&bucketName=fintrackaccountsprod&operation=upload`;
    setLoading(true);
    try {
      const response = await fetch(uploadUrl, {
        method: "GET",
        headers: { Authorization: `Bearer ${jwt_token}` },
      });
      if (!response.ok) throw new Error("Failed to get pre-signed URL");
      const presignedUrl = await response.text();
      if (!presignedUrl.startsWith("http")) {
        throw new Error("Invalid Pre-Signed URL received");
      }
      const uploadResponse = await fetch(presignedUrl, {
        method: "PUT",
        body: selectedFile,
        headers: { "Content-Type": contentType },
      });
      if (uploadResponse.ok) {
        showAlert("File uploaded successfully!", "success");
        handleCloseFileUploader();
      } else {
        const errorText = await uploadResponse.text();
        throw new Error(`Upload failed: ${uploadResponse.statusText}, Details: ${errorText}`);
      }
    } catch (error) {
      console.error("Upload Error:", error);
      showAlert("File upload failed.", "error");
    }
    setLoading(false);
  };

  const triggerS3File = async (params) => {
    const url = `https://s3service.sconexsoft.com/s3bucket/presigned-url?fileName=${params.VoucherNo}&bucketName=fintrackaccountsprod&operation=download`;
    try {
      const downloadResponse = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!downloadResponse.ok) {
        throw new Error(`Failed to get Pre-signed URL: ${downloadResponse.statusText}`);
      }

      const presignedUrl = await downloadResponse.text();
      if (!presignedUrl.startsWith("http")) {
        throw new Error("Invalid Pre-Signed URL received");
      }

      const fileResponse = await fetch(presignedUrl);
      if (!fileResponse.ok) throw new Error("Failed to fetch file from S3");

      const blob = await fileResponse.blob();

      const contentType = blob.type || "";
      const mimeToExt = {
        "image/jpeg": ".jpg",
        "image/png": ".png",
        "application/pdf": ".pdf",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
        "application/vnd.ms-excel": ".xls",
      };

      const baseName = params.VoucherNo || "download";
      const hasExt = baseName.includes(".");
      const ext = mimeToExt[contentType] || "";
      const fileName = hasExt ? baseName : `${baseName}${ext}`;

      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download Error:", error);
      showAlert("Failed to Download", "error");
    }
  };

  const tabs = [{ label: "Contra List" }, { label: "Create Contra Voucher" }];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <DashboardLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "12px",
          overflow: "auto",
          flexGrow: 1,
          boxShadow: "none",
          border: "none",
          height: "100%",
          pt: 2,
          backgroundColor: "transparent",
        }}
      >
        {/* ── Loading dialog ── */}
        <Dialog open={loading} onClose={() => setLoading(false)}>
          <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <CircularProgress color="primary" />
            <Typography variant="h6" style={{ marginTop: "20px" }}>
              Loading, please wait...
            </Typography>
          </DialogContent>
        </Dialog>

        {/* ── File Upload dialog ── */}
        {/* ── File Upload dialog ── */}
        <Dialog
          open={openFileFolder}
          onClose={handleCloseFileUploader}
          PaperProps={{
            sx: {
              borderRadius: "16px",
              padding: "8px",
              minWidth: "420px",
            },
          }}
        >
          <StyledTypographyA
            mt={2}
            sx={{ textAlign: "center", fontWeight: "bold", fontSize: "18px" }}
          >
            Upload File
          </StyledTypographyA>
          <DialogContent>
            <Box
              onClick={() => document.getElementById("voucher-file-input").click()}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                e.preventDefault();
                const droppedFile = e.dataTransfer.files[0];
                if (droppedFile) {
                  const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".xlsx", ".xls"];
                  const isValid = allowedExtensions.some((ext) =>
                    droppedFile.name.toLowerCase().endsWith(ext)
                  );
                  if (!isValid) {
                    showAlert(
                      "Only .jpg, .jpeg, .png, .pdf, .xlsx or .xls files are allowed!",
                      "error"
                    );
                    return;
                  }
                  setSelectedFile(droppedFile);
                }
              }}
              sx={{
                background: "linear-gradient(135deg,  #FFC107, #607D8B)",
                border: "2.5px dashed #ffffff",
                borderRadius: "14px",
                padding: "40px 20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                gap: 2,
                "&:hover": { opacity: 0.92 },
              }}
            >
              <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
                {["#fff", "#ffe082", "#ef9a9a"].map((color, i) => (
                  <Box
                    key={i}
                    sx={{
                      width: 36,
                      height: 44,
                      backgroundColor: color,
                      borderRadius: "4px",
                      opacity: 0.9,
                      transform: i === 1 ? "rotate(-5deg)" : i === 2 ? "rotate(5deg)" : "none",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "9px",
                      fontWeight: "bold",
                      color: "#555",
                    }}
                  >
                    {i === 0 ? "XLS" : i === 1 ? "PDF" : "IMG"}
                  </Box>
                ))}
              </Box>

              <input
                id="voucher-file-input"
                type="file"
                accept=".jpg,.jpeg,.png,.pdf,.xlsx,.xls"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                }}
              >
                <Box
                  sx={{
                    px: 2.5,
                    py: 1,
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#2e7d32",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  📄 {selectedFile ? selectedFile.name : "CHOOSE FILES"}
                </Box>
                <Box
                  sx={{
                    px: 1.5,
                    py: 1,
                    borderLeft: "1px solid #e0e0e0",
                    color: "#2e7d32",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  ∨
                </Box>
              </Box>

              <Typography sx={{ color: "#ffffff", fontSize: "13px", mt: 0.5 }}>
                {selectedFile ? `Selected: ${selectedFile.name}` : "or drop files here"}
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", pb: 2, gap: 2 }}>
            <StyledButton onClick={handleCloseFileUploader} color="secondary">
              Cancel
            </StyledButton>
            <StyledButton onClick={uploadFileToS3} color="primary" variant="contained">
              Submit
            </StyledButton>
          </DialogActions>
        </Dialog>

        {/* ── Delete confirm dialog ── */}
        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogContent>
            <Typography>Are you sure you want to delete this voucher?</Typography>
          </DialogContent>
          <DialogActions>
            <StyledButton
              onClick={() => {
                if (voucherToDelete) {
                  handleDeleteVoucher(
                    voucherToDelete,
                    companyIdToDelete,
                    fromDate,
                    toDate,
                    Company,
                    seachTypeForGet
                  );
                }
                setOpenDialog(false);
              }}
            >
              Yes
            </StyledButton>
            <StyledButton onClick={() => setOpenDialog(false)}>No</StyledButton>
          </DialogActions>
        </Dialog>

        {/* ── Snackbar ── */}
        <StyledSnackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          severity={alertType}
        >
          <StyledAlert onClose={handleClose} severity={alertType}>
            {message}
          </StyledAlert>
        </StyledSnackbar>

        {/* ── Tabs (same pattern as PaymentVoucher) ── */}
        <ResponsiveTabs
          tabs={tabs}
          activeTab={activeTab}
          onChange={handleTabChange}
          labelColor="secondary"
          bgColor="#e0f7fa"
        />

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            mt: 1,
            pt: 1,
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
          }}
        >
          {/* ════════════════════════════════════════
              TAB 0 — Voucher list
          ════════════════════════════════════════ */}
          {activeTab === 0 && (
            <Box
              sx={{
                overflowX: "auto",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
              }}
            >
              {/* Date filter row */}
              <Box sx={{ display: "flex", alignItems: "center", mb: 1, mr: 1 }}>
                <Grid container spacing={2} pt={0.7} alignItems="center">
                  <Grid item xs={12} sm={4} md={3} lg={2}>
                    <TextField
                      fullWidth
                      type="date"
                      label="From Date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      sx={MInput.b}
                      InputLabelProps={{ shrink: true, sx: { color: MInput.a } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={2}>
                    <TextField
                      fullWidth
                      type="date"
                      label="To Date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      sx={MInput.b}
                      InputLabelProps={{ shrink: true, sx: { color: MInput.a } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={2}>
                    <StyledButton onClick={fetchVoucherData}>Display</StyledButton>
                  </Grid>
                </Grid>
              </Box>

              {/* AG Grid */}
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{
                  flexGrow: 1,
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  border: "none",
                }}
              >
                <AgGridReact
                  ref={gridRef}
                  rowData={tableData}
                  columnDefs={columnDefs}
                  pagination
                  paginationPageSize={11}
                  pinnedBottomRowData={pinnedBottomData}
                  onFilterChanged={onFilterChanged}
                  onSortChanged={onFilterChanged}
                  getRowStyle={getRowStyle}
                  enableCellTextSelection={true}
                />
              </StyledAgGridContainer>
            </Box>
          )}

          {/* ════════════════════════════════════════
              TAB 1 — Voucher Form
          ════════════════════════════════════════ */}
          {activeTab === 1 && (
            <Box
              sx={{
                width: "100%",
                backgroundColor: "#FFFFFF",
                borderRadius: "15px",
                padding: 2,
              }}
            >
              {/* Header row */}
              <div style={{ ...entryStyles.divStyle }}>
                <StyledTypography>
                  {!isEditMode ? "Create Contra Voucher" : "Edit Voucher Details"}
                </StyledTypography>
                {isEditMode && (
                  <Tooltip title="Reset">
                    <StyledButtonC onClick={resetFormState}>
                      <RestartAltIcon />
                    </StyledButtonC>
                  </Tooltip>
                )}
              </div>

              <form autoComplete="off">
                <Box p={{ sm: 1, md: 2 }} pt={{ xs: 3, sm: 2 }}>
                  {/* ── Top fields row ── */}
                  <Grid container spacing={2}>
                    {/* Date */}
                    <Grid item xs={12} sm={6} md={3}>
                      <TextField
                        fullWidth
                        label="Date"
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        sx={MInput.b}
                        InputLabelProps={{ shrink: true, sx: { color: MInput.a } }}
                      />
                    </Grid>

                    {/* Account */}
                    <Grid item xs={12} sm={6} md={4}>
                      <Autocomplete
                        options={accounts}
                        getOptionLabel={(option) => option.accountName || ""}
                        value={
                          selectedAccount
                            ? accounts.find((item) => item.accountID === selectedAccount) || null
                            : null
                        }
                        onChange={(event, newValue) => {
                          setSelectedAccount(newValue ? newValue.accountID : "");
                        }}
                        disableClearable={false}
                        filterOptions={(options, state) => {
                          const input = state.inputValue.toLowerCase();
                          const startsWithInput = options.filter((option) =>
                            option.accountName.toLowerCase().startsWith(input)
                          );
                          const containsInput = options.filter(
                            (option) =>
                              !option.accountName.toLowerCase().startsWith(input) &&
                              option.accountName.toLowerCase().includes(input)
                          );
                          return [...startsWithInput, ...containsInput];
                        }}
                        PaperComponent={CustomPaper}
                        renderInput={(params) => (
                          <TextField
                            fullWidth
                            {...params}
                            label="Select Account"
                            variant="outlined"
                            required
                            sx={{
                              height: 43,
                              ...MInput.b,
                              "& .MuiInputBase-root": { height: "100%", minHeight: 43 },
                            }}
                            InputLabelProps={{
                              sx: { color: MInput.a, "&.Mui-focused": { color: "red" } },
                            }}
                          />
                        )}
                      />
                    </Grid>

                    {/* Voucher No (edit only) */}
                    {isEditMode && (
                      <Grid item xs={12} sm={6} md={3}>
                        <TextField
                          label="Voucher No"
                          value={voucherNo}
                          InputProps={{ readOnly: true }}
                          fullWidth
                          sx={MInput.b}
                          InputLabelProps={{ sx: { color: MInput.a } }}
                        />
                      </Grid>
                    )}
                  </Grid>

                  {/* ── Particulars table — NO inner scroll (mirrors PaymentVoucher) ── */}
                  <Box mt={2}>
                    <Table sx={{ width: "100%", tableLayout: "fixed" }}>
                      <TableBody>
                        {/* Header row */}
                        <TableRow sx={voucherMasterStyles.tableHead}>
                          <CustomTableCell
                            sx={{ width: "55%", minWidth: 0 }}
                            fontWeight="bold"
                            align="center"
                          >
                            Particulars
                          </CustomTableCell>
                          <CustomTableCell
                            sx={{ width: "25%", minWidth: 0 }}
                            fontWeight="bold"
                            align="center"
                          >
                            Amount
                          </CustomTableCell>
                          <CustomTableCell
                            sx={{ width: "20%", minWidth: 0 }}
                            fontWeight="bold"
                            align="center"
                          >
                            Add / Remove
                          </CustomTableCell>
                        </TableRow>

                        {/* Data rows */}
                        {rows.map((row, index) => (
                          <TableRow key={index}>
                            {/* Particulars cell */}
                            <TableCell sx={{ width: "55%", minWidth: 0, px: 1, py: 0.5 }}>
                              <Autocomplete
                                fullWidth
                                options={accounts}
                                getOptionLabel={(option) => option.accountName}
                                value={
                                  accounts.find((item) => item.accountID === row.particular) || null
                                }
                                onChange={(event, value) =>
                                  handleRowChange(index, "particular", value ? value.accountID : "")
                                }
                                disableClearable={false}
                                filterOptions={(options, state) => {
                                  const input = state.inputValue.toLowerCase();
                                  const startsWithInput = options.filter((option) =>
                                    option.accountName.toLowerCase().startsWith(input)
                                  );
                                  const containsInput = options.filter(
                                    (option) =>
                                      !option.accountName.toLowerCase().startsWith(input) &&
                                      option.accountName.toLowerCase().includes(input)
                                  );
                                  return [...startsWithInput, ...containsInput];
                                }}
                                PaperComponent={CustomPaper}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Select Account"
                                    variant="outlined"
                                    sx={{
                                      ...MInput.b,
                                      "& .MuiInputBase-root": { minHeight: 43 },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: MInput.a,
                                        "&.Mui-focused": { color: "red" },
                                      },
                                    }}
                                  />
                                )}
                              />
                            </TableCell>

                            {/* Amount cell */}
                            <TableCell sx={{ width: "25%", minWidth: 0, px: 1, py: 0.5 }}>
                              <TextField
                                fullWidth
                                value={row.amount}
                                onChange={(e) => handleRowChange(index, "amount", e.target.value)}
                                sx={MInput.b}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">₹</InputAdornment>
                                  ),
                                }}
                                InputLabelProps={{ sx: { color: MInput.a } }}
                              />
                            </TableCell>

                            {/* Add/Remove cell */}
                            <TableCell
                              align="center"
                              sx={{ width: "20%", minWidth: 0, px: 1, py: 0.5 }}
                            >
                              <ViewButton type="button" onClick={handleAddItem}>
                                <AddIcon />
                              </ViewButton>
                              <DeleteButton type="button" onClick={() => handleRemoveItem(index)}>
                                <DeleteIcon />
                              </DeleteButton>
                            </TableCell>
                          </TableRow>
                        ))}

                        {/* Total row */}
                        <TableRow>
                          <CustomTableCell fontWeight="bold" align="center" colSpan={1}>
                            Total Amount
                          </CustomTableCell>
                          <CustomTableCell fontWeight="bold" align="center" colSpan={2}>
                            <strong>
                              {`₹ ${totalAmount.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`}
                            </strong>
                          </CustomTableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>

                  {/* ── Narration ── */}
                  <Grid container spacing={2} mt={1}>
                    <Grid item xs={12}>
                      <TextField
                        label="Narration"
                        fullWidth
                        multiline
                        rows={2}
                        value={selectedNarration}
                        onChange={(e) => setNarration(e.target.value)}
                        sx={MInput.b}
                        InputLabelProps={{ sx: { color: MInput.a } }}
                      />
                    </Grid>
                  </Grid>

                  {/* ── Save button ── */}
                  <MDBox mt={3} mb={0} gap={1} display="flex" justifyContent="flex-end">
                    <StyledButton type="button" onClick={handleSave}>
                      {isEditMode ? "Update" : "Save"}
                    </StyledButton>
                  </MDBox>
                </Box>
              </form>
            </Box>
          )}
        </Box>
      </Box>
    </DashboardLayout>
  );
}

ContraVoucher.propTypes = {
  node: PropTypes.shape({
    rowIndex: PropTypes.number.isRequired,
  }).isRequired,
  api: PropTypes.shape({
    getDisplayedRowAtIndex: PropTypes.func.isRequired,
  }).isRequired,
};
